import React from "react";
import { LoadingBall } from "@ingka/loading";
import "@ingka/loading/dist/style.css";

type FixaLoadingBallProps = {
  size: "small" | "medium" | "large";
  color?: "emphasised" | "primary" | "secondary";
};

const FixaLoadingBall: React.FC<FixaLoadingBallProps> = (
  props: FixaLoadingBallProps
) => {
  return <LoadingBall {...props} />;
};

export default FixaLoadingBall;
